<template>
  <div id="app" :style="{ width, minWidth: width }">
    <SlideWrapper
      :steps="stepsArray"
      :startAtStep="startAtStep"
      :currentStep="currentStep"
      :showSlidePostEnding="showSlidePostEnding"
      :showSlidePreBegin="showSlidePreBegin"
      :currentEndingStep="currentEndingStep"
      :currentStartingStep="currentStartingStep"
      :startingSteps="startingSteps"
      :endingSteps="endingSteps"
      :showLoader="showLoader"
    >
      <QuestionStep
        v-for="questionObject in questionsArray"
        :slot="questionObject.id"
        :key="questionObject.id"
        :questionObject="questionObject"
      />
      <LikelyProductsList slot="result" :products="products" />
      <GetUserDetails slot="storage" :products="products" />
      <Loader slot="loader" :showLoader="showLoader" />
    </SlideWrapper>
  </div>
</template>

<script>
// import Vue from "vue";
// import { library } from '@fortawesome/fontawesome-svg-core'
// import { faArrowRight,faPaperPlane,faCheck } from '@fortawesome/free-solid-svg-icons'
// import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// library.add(faCheck);
// library.add(faArrowRight);
// library.add(faPaperPlane);

// vue.component('fontAwesomeIcon', FontAwesomeIcon)
import SlideWrapper from "./components/SlideWrapper.vue";
import QuestionStep from "./components/QuestionStep.vue";
import LikelyProductsList from "./components/LikelyProductsList.vue";
import Loader from "./components/Loader.vue";
import GetUserDetails from "./components/GetUserDetails.vue";
//importing store here because building with target wc does not use main.js
import store from "./store";
import { mapState, mapActions } from "vuex";

export default {
  store,
  name: "App",
  components: {
    SlideWrapper,
    QuestionStep,
    LikelyProductsList,
    GetUserDetails,
    Loader
  },
  data() {
    return {
      size: { width: "100%", height: "100vh" }
    };
  },
  computed: {
    ...mapState([
      "questionsArray",
      "currentStep",
      "currentEndingStep",
      "startAtStep",
      "showSlidePostEnding",
      "showSlidePreBegin",
      "products",
      "endingSteps",
      "startingSteps",
      "currentStartingStep",
      "siteSettings",
      "showLoader",
      "resultsSharedPageView"
    ]),
    isOnResultsPage() {
      return this.showSlidePostEnding && this.currentEndingStep === "result";
    },
    stepsArray() {
      return this.questionsArray.map(questionObject => questionObject.id);
    },
    height() {
      if (!this.isOnResultsPage) {
        return this.siteSettings.height;
      }
      return "";
    },
    width() {
      return this.siteSettings.width;
    }
  },
  methods: {
    ...mapActions(["setSiteData", "reAuth"]),
    doVisibilityCheck() {
      // const { hidden } = document;
      // is document hidden?
      // if(!hidden) {
      //   this.reAuth({reduceRetry:false});
      // }
    }
    // ...mapMutations(["setSiteSettings"])
  },
  created() {
    //console.log(window.quiz_data);
    if (window.quiz_data) {
      this.setSiteData(window.quiz_data);
      //overriding console.log

      console.log = function(){};
      document.addEventListener("visibilitychange", this.doVisibilityCheck);
    }
  }
};
</script>

<style lang="scss">
#app {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px auto;
  @media only screen and (max-width: 900px) {
    margin: 5px;
    width: 95% !important;
  }
}
h1{
  text-align: center;
  line-height: 35px;
  word-break: break-word;
}
@media only screen and (max-width: 400px) {
  h1{
    font-size: 1.2em !important;
  }
}
</style>
